import commonStyles from "../../styles/Common.module.css";
import React, { useEffect, useState } from "react";
import { Button, Card, CardContent, Typography, TextField, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";

const HoverCard = styled(Card)(({ theme }) => ({
    cursor: "pointer",
    transition: "transform 0.2s, box-shadow 0.2s",
    '&:hover': {
        transform: "scale(1.02)",
        boxShadow: theme.shadows[6],
        backgroundColor: theme.palette.action.hover
    }
}));


export const MentorBatches = () => {
    const navigate = useNavigate();
    const [batches, setBatches] = useState([]);
    const [newBatchForm, setNewBatchForm] = useState({
        course_id: "",
        batch_name: "",
        total_seats: "",
        seats_left: "",
        batch_start_date: "",
        enrollment_start_date: "",
        enrollment_last_date: "",
        whatsapp_group_link: ""
    });

    useEffect(() => {
        fetchBatches();
    }, []);

    const fetchBatches = async () => {
        const res = await axios.get("https://api.sovrenn.com/mentor-batches/list", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("sov_user"),
            },
        });
        setBatches(res.data.data);
    };

    const handleAddBatch = async () => {
        await axios.post("https://api.sovrenn.com/mentor-batches/add", newBatchForm, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("sov_user"),
                "Content-type": "application/json"
            },
        });
        setNewBatchForm({
            course_id: "",
            batch_name: "",
            total_seats: "",
            seats_left: "",
            batch_start_date: "",
            enrollment_start_date: "",
            enrollment_last_date: "",
            whatsapp_group_link: ""
        });
        fetchBatches();
    };

    return (
        <div className={commonStyles.MainContainer}>

            <div className={commonStyles.headerDiv}>
                <h2>Mentor Batches</h2>

                <div>
                    <Link to="/mentor/callback-requests">
                        <Button color="secondary" variant="outlined" sx={{ width: "200px" }}
                        >Callback Requests</Button>
                    </Link>
                </div>
            </div>

            <Grid container spacing={4}>
                {batches.map((batch) => (
                    <Grid item xs={12} md={6} lg={6} key={batch._id}>
                        <Card onClick={() => navigate(`/mentor/batches/${batch._id}`)} style={{ cursor: "pointer" }}>
                            <HoverCard onClick={() => navigate(`/mentor/batches/${batch._id}`)}>
                                <CardContent>
                                    <Typography variant="h5">{batch.batch_name}</Typography>
                                    <Typography variant="h6" fontSize="large">Course: {batch.course?.title}</Typography>
                                    <Typography variant="h6" fontSize="large">Start: {moment(batch.batch_start_date).format("Do MMMM YY")}</Typography>
                                    <Typography variant="h6" fontSize="large">Seats: {batch.seats_left}/{batch.total_seats}</Typography>
                                </CardContent>
                            </HoverCard>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </div>
    )
};